export const environment = {
  mockData: false,
  production: false,
  apiUrl: 'https://ejui7ox2t1.execute-api.eu-central-1.amazonaws.com/test/v1/api',
  delayBeforeOpenRatingDialog: 60000,
  ratingUrl: 'https://www.wix.com/app-market/add-review/4750adaf-e490-4372-8e70-1d8d95fe633a',
};
